/**
 * Macro-aree Shipper per onboarding: prima regola che matcha il pathname vince.
 * Profilo / impostazioni (/shipper/profile) è escluso (nessuna regola).
 */

export const SHIPPER_ONBOARDING_SECTION_IDS = [
    "control-hub",
    "operations",
    "coordination",
    "commercial",
    "network",
] as const;

export type ShipperOnboardingSectionId = (typeof SHIPPER_ONBOARDING_SECTION_IDS)[number];

type Rule = { id: ShipperOnboardingSectionId; prefix: string };

/** Ordine: dalla più specifica alla più generica dove serve (nessun overlap attuale). */
const RULES: readonly Rule[] = [
    { id: "control-hub", prefix: "/shipper/control-hub" },
    { id: "operations", prefix: "/shipper/containers" },
    { id: "operations", prefix: "/shipper/live-tracking" },
    { id: "operations", prefix: "/shipper/documents" },
    { id: "coordination", prefix: "/shipper/activity" },
    { id: "coordination", prefix: "/shipper/issues" },
    { id: "coordination", prefix: "/shipper/review-center" },
    { id: "commercial", prefix: "/shipper/orders" },
    { id: "commercial", prefix: "/shipper/quotes" },
    { id: "network", prefix: "/shipper/business-partners" },
    { id: "network", prefix: "/shipper/address-book" },
] as const;

function matchesPrefix(pathname: string, prefix: string): boolean {
    return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

/**
 * Risolve la macro-area onboarding per un pathname, o null se fuori scope.
 */
export function getShipperOnboardingSectionId(pathname: string): ShipperOnboardingSectionId | null {
    for (const rule of RULES) {
        if (matchesPrefix(pathname, rule.prefix)) {
            return rule.id;
        }
    }
    return null;
}

export function shipperOnboardingSeenStorageKey(sectionId: ShipperOnboardingSectionId): string {
    return `shipper.onboarding.section.${sectionId}.seen`;
}

/** Chiave i18n sotto `shipper.<key>.slides` in namespace `pages:onboarding`. */
export const SHIPPER_ONBOARDING_SECTION_I18N_KEYS: Record<ShipperOnboardingSectionId, string> = {
    "control-hub": "controlHub",
    operations: "operations",
    coordination: "coordination",
    commercial: "commercial",
    network: "network",
};
